import { useState, useCallback } from 'react'
import moment from 'moment'
import { ButtonType } from '../../../../utils/completionQueries'

export function useMonthSelection() {
  const [month, setMonth] = useState(moment().format('YYYY-MM'))
  const [selectedButton, setSelectedButton] = useState<ButtonType>(null)

  const handleButtonClick = useCallback(
    (button: Exclude<ButtonType, null>) => {
      if (selectedButton === button) {
        setSelectedButton(null)
        setMonth(moment().format('YYYY-MM'))
      } else {
        setSelectedButton(button)
        switch (button) {
          case 'current':
            setMonth(moment().format('YYYY-MM'))
            break
          case 'last':
            setMonth(moment().subtract(1, 'month').format('YYYY-MM'))
            break
          case 'last2':
            setMonth(moment().subtract(2, 'months').format('YYYY-MM'))
            break
          case 'last3':
            setMonth(moment().subtract(3, 'months').format('YYYY-MM'))
            break
          case 'last6':
            setMonth(moment().subtract(6, 'months').format('YYYY-MM'))
            break
        }
      }
    },
    [selectedButton]
  )

  return {
    month,
    setMonth,
    selectedButton,
    handleButtonClick,
  }
}
